<template>
    <template
        v-if="!group?.hideInMenu && group.items?.length && hasVisibleItems"
    >
        <v-list-subheader
            v-if="!group?.hideTitleInMenu"
        >
            <v-list-item-title
                class="mt-6 mb-2 text-label-medium text-uppercase font-weight-bold"
            >
                {{ group.title }}
            </v-list-item-title>
        </v-list-subheader>

        <AccountNavItem
            v-for="item in group.items"
            :key="`${idPrefix}-${item.id}`"
            :item="item"
            :extra-item-class="extraItemClass"
            :slim="slim"
        ></AccountNavItem>
    </template>
</template>

<script lang="ts" setup>
    import AccountNavItem from '~/components/account/account-nav/AccountNavItem/AccountNavItem.vue';
    import type { AccountNavGroupItem } from '~/types';

    const props = withDefaults(
        defineProps<{
            group: AccountNavGroupItem;
            extraItemClass?: Nilish<string>;
            idPrefix?: string;
            slim?: boolean;
        }>(),
        {
            idPrefix: 'nav-item'
        }
    );

    const hasVisibleItems = computed<boolean>(() => !props.group.items.every((g) => g.hideInMenu));
</script>

<style lang="scss"></style>
